export default {
  addOns: 'Adicionais',
  availability: 'Disponibilidade',
  availabilityDaySelector: 'Seletor de data de disponibilidade',
  unavailable: 'Indisponível',
  person: 'pessoa',
  people: 'pessoas',
  reserveNow: 'Reserve agora',
  selectTime: 'Selecionar horário',
  select: 'Selecionar',
  reserve: 'Reservar',
  time: 'Hora',
  tier: 'Nível',
  questions: 'Perguntas',
  addToCart: 'Adicionar ao carrinho',
  checkout: 'Finalizar compra',
  total: 'Total',
  whatsIncluded: 'O que está incluído',
  showMore: 'Mostrar mais',
  showLess: 'Mostrar menos',
  session: 'Sessão',
  viewDetails: 'Ver detalhes',
  findAvailability: 'Encontrar disponibilidade',
  loading: 'Carregando',
  capacity: 'Capacidade',
  noAvailableSessionsOnThisDate: 'Nenhuma sessão disponível nesta data',
  noGroupAvailableOnThisDateAndTime:
    'Nenhum(a) {{groupTitle}} disponível nesta data e hora',
  noCollectionFound: 'Nenhuma coleção encontrada!',
  noResourceGroupFound: 'Nenhum grupo de recursos encontrado!',
  noData: 'Sem dados!',
  continue: 'Continuar',
  night: 'noite',
  nights: 'noites',
  noAvailableSessionsForSelectedDates:
    'Algumas datas em sua seleção não têm sessões disponíveis. Por favor, selecione datas diferentes.',
  from: 'de',
  dateRangeSelector: 'Seletor de intervalo de datas',
  priceTierRadioGroup: 'Seletor de nível de preço',
  startTime: 'Hora de início',
  duration: 'Duração',
  lengthOfStay: 'Duração da estadia',
  startDate: 'Data de início',
  endDate: 'Data de término',
  selectDates: 'Selecionar datas',
  more: 'Mais',
  selectStartTime: 'Escolha uma hora de início',
  endTime: 'Hora de término',
  selectEndTime: 'Escolha uma hora de término',
  morning: 'Manhã',
  afternoon: 'Tarde',
  save: 'Guardar',
  selectDuration: 'Escolha uma duração',
  forLength: 'por {{length}}',
  moreDates: 'mais {{count}}',
  addDate: 'Adicionar data',
  start: 'Início',
  end: 'Término',
  pickupFrom: 'Retirada a partir das',
  returnBy: 'Devolução até às',
  day: 'dia',
  days: 'dias',
  hour: 'hora',
  hours: 'horas',
};
